import { render, staticRenderFns } from "./mainShop.vue?vue&type=template&id=51a9a703&scoped=true&"
import script from "./mainShop.vue?vue&type=script&lang=js&"
export * from "./mainShop.vue?vue&type=script&lang=js&"
import style0 from "./mainShop.vue?vue&type=style&index=0&id=51a9a703&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a9a703",
  null
  
)

export default component.exports